import React from 'react';
import styled from 'styled-components';
import { useTemplate } from '../../context/TemplateContext';
import ElementProperties from './ElementProperties';
import TemplateProperties from './TemplateProperties';

const PropertiesPanel = ({ selectedElement }) => {
  const { template } = useTemplate();

  return (
    <PanelContainer>
      <PanelHeader>
        <h2>{selectedElement ? 'Element Properties' : 'Template Properties'}</h2>
      </PanelHeader>
      
      <PanelContent>
        {selectedElement ? (
          <ElementProperties element={selectedElement} />
        ) : (
          <TemplateProperties template={template} />
        )}
      </PanelContent>
    </PanelContainer>
  );
};

const PanelContainer = styled.div`
  width: 300px;
  background-color: #f5f7fa;
  border-left: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const PanelHeader = styled.div`
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  
  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
`;

const PanelContent = styled.div`
  padding: 15px;
  flex: 1;
  overflow-y: auto;
`;

export default PropertiesPanel;
